module.exports = __webpack_public_path__ + "static/media/Finiquitos_Renuncia.6dce4bf3.svg";